import { render, staticRenderFns } from "./ChoiceLogo.vue?vue&type=template&id=e48c4ff4&scoped=true"
import script from "./ChoiceLogo.vue?vue&type=script&lang=js"
export * from "./ChoiceLogo.vue?vue&type=script&lang=js"
import style0 from "./ChoiceLogo.vue?vue&type=style&index=0&id=e48c4ff4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48c4ff4",
  null
  
)

export default component.exports